import { useTranslation } from "react-i18next";
import { renderItem } from "./renderItem";
import "../../style.scss";

const fields = [
    "weekly-overtime",
    "daily-overtime",
    "daily-double-time",
    "daily-double-time-and-half",
    "four-consecutive-day",
    "five-consecutive-day",
    "six-consecutive-day",
    "consecutive-day",
    "all-hours-worked-on",
];

const OvertimeRules = ({ data }) => {
    const { t } = useTranslation();

    return (
        <div className="tooltip-content-style">
            <h3 className="font-weight-bolder text-left mb-1">{t("overtime")}</h3>
            {fields.map((item, i) => {
                return data?.[item] && (
                    <div key={i}>
                        <div>
                        <h4 className="mb-2 text-left" style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}>{t(item)}</h4>
                            {data?.[item]?.status && renderItem(data[item].status, "status", t)}
                            {data?.[item]?.defaultPayCode &&
                                renderItem(data[item].defaultPayCode, "default-pay-code", t)}
                            {data?.[item]?.hourTypes && renderItem(data[item].hourTypes, "hour-types", t)}
                            {data?.[item]?.value && renderItem(data[item].value, "value", t)}
                            {data?.[item]?.payCodes && renderItem(data[item].payCodes, "pay-codes", t)}
                            {data?.[item]?.calculateOtherOvertime && renderItem(data[item].calculateOtherOvertime, "calculate-other-overtimes", t)}
                            {data?.[item]?.overtimes && renderItem(data[item].overtimes, "overtimes", t)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default OvertimeRules;
